import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-ceromony',
  templateUrl: './ceromony.component.html',
  styleUrls: ['./ceromony.component.css']
})
export class CeromonyComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
